import { render, staticRenderFns } from "./LawInvoiceUpdateDetailForm.vue?vue&type=template&id=5e5ce36c&"
import script from "./LawInvoiceUpdateDetailForm.vue?vue&type=script&lang=js&"
export * from "./LawInvoiceUpdateDetailForm.vue?vue&type=script&lang=js&"
import style0 from "./LawInvoiceUpdateDetailForm.vue?vue&type=style&index=0&id=5e5ce36c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports